
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'Equipment',
})
export default class extends Vue {
}
